/* =====================================================================
 * Rebo Mode Store — 에이전트 응답 모드 전역 상태
 *
 * auto  : 에이전트가 판단하여 해결 (기본값)
 * fast  : 빠르게 답변
 * plan  : 복잡한 문제 해결
 * ===================================================================== */

import { create } from 'zustand';
import i18n from '@auw/i18n';

export type ReboMode = 'auto' | 'fast' | 'plan' | 'skill';

export interface ReboModeOption {
  id: ReboMode;
  label: string;
  description: string;
}

export function getReboModeOptions(): ReboModeOption[] {
  return [
    { id: 'auto', label: i18n.t('common:reboMode.autoLabel'), description: i18n.t('common:reboMode.autoDesc') },
    { id: 'fast', label: i18n.t('common:reboMode.fastLabel'), description: i18n.t('common:reboMode.fastDesc') },
    { id: 'plan', label: i18n.t('common:reboMode.planLabel'), description: i18n.t('common:reboMode.deepDesc') },
    { id: 'skill', label: i18n.t('common:reboMode.skillLabel'), description: i18n.t('common:reboMode.skillDesc') },
  ];
}

interface ReboModeState {
  mode: ReboMode;
  setMode: (mode: ReboMode) => void;
}

export const useReboModeStore = create<ReboModeState>((set) => ({
  mode: 'auto',
  setMode: (mode) => set({ mode }),
}));
